/**
 * @file 校验函数库，用于各种规则的校验
 * @author qiaogang
 * @date 2019-08-28
 */

/**
 * 简单的校验手机号码
 * @param {string} phone
 * @return {boolean}
 */
export function validateMobile(phone, countryCode = 86) {
  phone = String(phone);
  if (countryCode == 86) {

    // 简单判断国内手机号
    const regExp = /^1\d{10}$/;
    return regExp.test(phone);
  } else {
    return true;
  }

  // else if (countryCode == 886) {

  //   //  台湾校验
  //   const regExp = /^09\d{8}$/;
  //   return regExp.test(phone);
  // } else if (countryCode == 853) {

  //   //  澳门校验
  //   const regExp = /^6\d{7}$/;
  //   return regExp.test(phone);
  // } else if (countryCode == 852) {

  //   //  香港校验
  //   const regExp = /^(6|9)\d{7}$/;
  //   return regExp.test(phone);
  // }
}
